var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatistics = function SvgStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.04,
    height: 45.405,
    y: 14.595,
    fill: "#fff",
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.04,
    height: 30.27,
    x: 50.772,
    y: 29.73,
    fill: "#fff",
    rx: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19.04,
    height: 60,
    x: 25.386,
    fill: "#FF4A5C",
    rx: 5
  })));
};
export default SvgStatistics;